export const ADD_TASK = "add_task";
export const REM_TASK = "rem_task";
export const ADD_ALL_TASKS = "add_all_tasks";
export const UPDATE_TASK = "update_task";

export const COMPLETE_TASK = "complete_task";
export const INCOMPLETE_TASK = "incomplete_task";
export const ADD_ALL_COMPLETE_TASKS = "add_all_complete_tasks";

export const UPDATE_BULK_OPTIONS = "update_bulk_options"